import React,{useState,useEffect} from 'react';
import {Button} from 'react-bootstrap';
import {Modal} from 'react-bootstrap';
import "./ModalConfirmacion.css";
function ModalConfirmacionGeneral(datos) {
    const {comando,dispositivo,ids,cerrarModal} = datos;
    var [nombreComando, setNombreComando] = useState('');
    const [abrirModalEnviado, setAbrirModalEnviado] = useState(false);

    useEffect(()=>{
      switch(comando){
        case 'ON':
          setNombreComando('START');
        break;

        case 'OFF':
          setNombreComando('STOP');
        break;

        case 'WIND':
          setNombreComando('Posición Viento');
        break;

        case 'SNOW':
          setNombreComando('Posición Nieve');
        break;

        case 'CLEAN':
          setNombreComando('Posición Limpieza');
        break;

        case 'RESET':
          setNombreComando('Reset');
        break;

        case 'AUTO':
          setNombreComando('Automático');
        break;

        case 'RESET_ALARM':
          setNombreComando('Reset Alarma')
        break;
        
        case 'MANUAL':
          setNombreComando('Manual');
        break;
        
        default:
          setNombreComando('Comando inválido');
      }
    },[comando]);


    function enviarComandos(comando,dispositivo,ids){
      fetch( window.location.protocol+"//"+window.location.hostname+"/api" + '/commands/sendCommand', {
      method: 'POST',
      credentials: 'include',
      headers:{
          'idDevice': dispositivo,
          'idWithinDeviceTable': ids,
          'command': comando
      }
      })
      .then(response => { console.log(response)})
      .catch(e => { console.error(e);})
    }

  return (
    <div>¿Está seguro de enviar <strong>{nombreComando}</strong>?
    <br />
    <Button type="button" className="button_confirm boton-aceptar" variant="success" size="sm" onClick={() => {enviarComandos(comando,dispositivo,ids);setAbrirModalEnviado(true);}} >ACEPTAR</Button>
    <Button type="button" className="button_cancel boton-cancelar" variant="danger" size="sm" onClick={() => {cerrarModal(false)}}>CANCELAR</Button>

    <Modal centered show={abrirModalEnviado} onHide={() => (setAbrirModalEnviado(false), cerrarModal(false))} backdrop="static" aria-labelledby="enviado" >
      <Modal.Header closeButton>
        <Modal.Title>Confirmación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <a>Comando enviado, puede que tarde unos minutos en completarse.</a>
        <br />
        <Button type="button" className="button_confirm boton-aceptar-enviado" variant="success" size="sm" onClick={() => {setAbrirModalEnviado(false);cerrarModal(false);}}>ACEPTAR</Button>
      </Modal.Body>
    </Modal>
    </div>
  )
}

export default ModalConfirmacionGeneral